module.exports = __webpack_public_path__ + "static/media/NSWY.5327c46f.png";